import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { brand } from '../../theme';

// One of the three big home-page actions: Map / Directions / Vendors.
// Designed as a full-card link with a generous tap area so it works for
// older users on touch devices.
const PrimaryActionCard = ({ icon: Icon, label, subtitle, to }) => (
  <Box
    component={Link}
    to={to}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      textDecoration: 'none',
      color: brand.textPrimary,
      backgroundColor: brand.paper,
      border: `1px solid ${brand.hairline}`,
      borderRadius: 3,
      p: { xs: 3, sm: 3.5 },
      minHeight: { xs: 168, sm: 240 },
      boxShadow: '0 1px 2px rgba(16, 36, 62, 0.04)',
      transition: 'transform 200ms ease-out, box-shadow 200ms ease-out, border-color 200ms ease-out',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 28px rgba(16, 36, 62, 0.12)',
        borderColor: brand.navy,
        '& .pa-arrow': {
          transform: 'translateX(4px)',
          color: brand.navy,
        },
      },
      '&:focus-visible': {
        outline: `3px solid ${brand.brass}`,
        outlineOffset: 4,
      },
    }}
  >
    <Box
      sx={{
        width: { xs: 56, sm: 64 },
        height: { xs: 56, sm: 64 },
        borderRadius: 2,
        backgroundColor: brand.cream,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: brand.navy,
      }}
    >
      <Icon sx={{ fontSize: { xs: 32, sm: 36 } }} />
    </Box>

    <Box sx={{ mt: 3 }}>
      <Typography
        component="div"
        sx={{
          fontFamily: '"Fraunces", Georgia, serif',
          fontWeight: 600,
          fontSize: { xs: '1.75rem', sm: '1.875rem' },
          lineHeight: 1.1,
          color: brand.navy,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          mt: 0.75,
          color: brand.textSecondary,
          fontSize: '1.0625rem',
        }}
      >
        {subtitle}
      </Typography>
    </Box>

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <ArrowForwardIcon
        className="pa-arrow"
        sx={{
          color: brand.textSecondary,
          transition: 'transform 200ms ease-out, color 200ms ease-out',
        }}
      />
    </Box>
  </Box>
);

export default PrimaryActionCard;
